/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Component } from "@angular/core";
import { NzSelectClearComponent } from "ng-zorro-antd/select";

@Component({
  selector: "ui-select-clear",
  templateUrl: "select-clear.component.html",
  host: {
    "(click)": "onClick($event)",
  },
})
export class UiSelectClearComponent extends NzSelectClearComponent {}
